var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0557 22.3229L39.3472 18.4688L47.0557 14.6145C48.4345 13.9252 48.4359 11.9506 47.0557 11.2603L24.9306 0.19771C24.6702 0.0676663 24.3831 -3.05176e-05 24.092 -3.05176e-05C23.8009 -3.05176e-05 23.5138 0.0676663 23.2534 0.19771L1.12831 11.2603C-0.25057 11.9499 -0.251976 13.9245 1.12831 14.6145L8.83656 18.4688L1.12812 22.3229C-0.250663 23.0124 -0.25207 24.9866 1.12812 25.677L8.83665 29.5314L1.12822 33.3854C-0.25057 34.075 -0.251976 36.0492 1.12822 36.7395L23.2533 47.8021C23.5137 47.9322 23.8008 48 24.0919 48C24.383 48 24.6701 47.9322 24.9305 47.8021L47.0556 36.7395C48.4345 36.0499 48.4359 34.0757 47.0556 33.3853L39.3473 29.5314L47.0558 25.677C48.4346 24.9877 48.436 23.0132 47.0558 22.3228L47.0557 22.3229ZM24.0919 3.97126L42.0243 12.9375L24.0919 21.9035L6.15961 12.9375L24.0919 3.97126ZM42.0243 35.0626L24.0919 44.0286L6.15961 35.0626L13.0294 31.6276L23.2533 36.7395C23.5137 36.8697 23.8008 36.9374 24.0919 36.9374C24.383 36.9374 24.6701 36.8697 24.9305 36.7395L35.1544 31.6275L42.0243 35.0626ZM24.0919 32.9661L6.15961 24.0001L13.0294 20.5651L23.2533 25.677C23.5137 25.8071 23.8008 25.8749 24.0919 25.8749C24.383 25.8749 24.6701 25.8071 24.9305 25.677L35.1544 20.565L42.0243 24.0001L24.0919 32.9661Z",
    fill: "#AAD2EF",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluations);
export default __webpack_public_path__ + "static/media/evaluations.6c73fec4426918fe1857b873ba6875a8.svg";
export { ForwardRef as ReactComponent };